(ns hai.web-app.version
  "Tracks whether the platform has advertised a web-app version newer than the
  one this bundle was compiled from. The platform sends the latest deployed
  version on every response via the `X-Web-App-Version` header (see
  `hai.web-app.util.fetch`); once we see a strictly-newer build number we latch
  `::available?` on so the UI can offer the user a reload."
  (:require
   [hai.ui.rf-sugar :refer [defevent defsub]])
  (:require-macros
   [hai.web-app.macros :as macros]))

(def ^:private client-build-number
  "The monotonic build number (`:patch`, from `git rev-list --count`) this bundle
  was compiled from."
  (:patch (macros/version)))

(defn- ->build-number
  "The trailing build number from a version string like 'v0.746.17128' → 17128,
  or nil if it doesn't look like a version."
  [version-str]
  (when (string? version-str)
    (when-let [m (re-find #"\d+$" version-str)]
      (js/parseInt m 10))))

(defsub ::new-version-available? [db]
  (get db ::new-version-available? false))

(defevent ::server-version-seen [db version-str]
  (let [server (->build-number version-str)]
    ;; Only ever latch on, and only for a strictly-newer build — never flip back
    ;; off, and never react to an equal/older version (which happens routinely
    ;; during a rolling deploy or CDN cache lag).
    (if (and server
             (int? client-build-number)
             (> server client-build-number))
      (assoc db ::new-version-available? true)
      db)))
